module.exports = function() {
  return new Worker(__webpack_public_path__ + "cc294250024a9903841b.worker.js");
};